<template>
    <div class="view12Wrapper shadowRadius">
        <div class="tipsGlobalText clearMarginCls" v-html="tips">
            {{tips}}
        </div>
        <div class="goodCommentCls">
            <img src="../../assets/img/goodComment.png" alt="神评论" class="goodComment">
        </div>
        <div class="v12Items">
            <div class="commentWrapper">
                <div class="newsTitle marginCls">
                    {{list.title||"标题"}}
                </div>
                <div class="commentBox">
                    <div class="leftStr"><img src="../../assets/img/leftStr.png" alt="" class="leftStrImg"></div>
                    <div class="commentBody">
                        <span class="commentText">{{list.value}}</span>
                    </div>
                    <div class="rightStr"><img src="../../assets/img/rightStr.png" alt="" class="rightStrImg"></div>
                </div>

            </div>

        </div>
    </div>
</template>
<script>
    import {mapState, mapActions, mapMutations} from "vuex";
    import $ from "jquery";

    export default {
        name: "View12",
        components: {},
        props: {
            list: {
                type: Object,
                default: {}
            },
            tips: {
                type: String,
                default: ""
            }
        },
        data() {
            return {
                defaultAvatar: "https://dcdn.thecover.cn/robot/avatar.png"
            };

        },
        mounted() {

        },
        methods: {
            onAsk(name, value) {
                this.$emit("on-ask", name, value);
            },
            onMore(type) {
                if (type === 3) {
                    this.$emit("on-more");
                }

            }
        }
    };
</script>
<style lang="less" scoped>
    .view12Wrapper {
        background: rgba(255, 255, 255, 1);
        padding: .32rem .3rem;
        width: 8.6rem;
        position: relative;
        .goodCommentCls {
            position: absolute;
            bottom: 0rem;
            right: .1rem;

            .goodComment {
                width: 3rem;
                height: 1.2rem;
            }

        }
        .v12Items {
            padding: .26rem;

            .commentWrapper {


                .marginCls {
                    margin: .2rem 0 .2rem 0;
                    line-height: .5rem;
                }

                .commentBox {


                    width: 100%;
                    display: flex;


                    .commentBody {
                        position: relative;
                        flex: 1;

                        margin: 10px;
                    }



                    .leftStr {
                        width: .6rem;

                        .leftStrImg {
                            width: .5rem;
                            height: .5rem;
                        }
                    }

                    .rightStr {
                        width: .4rem;


                        .rightStrImg {
                            width: .26rem;
                            height: .26rem;
                        }

                    }

                    .commentText {
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 5;
                        -webkit-box-orient: vertical;
                        font-size: 0.425rem;
                        color: #191919;
                        line-height: 0.52rem;
                        padding: 0.3rem 0 0 0;
                    }

                }





            }

            .bottomWrapper {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: .5rem;

                .userInfo {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .avatar {
                        width: 1.2rem;
                        height: 1.2rem;
                        border: 1px solid #ccc;
                        border-radius: 50%;
                        margin-right: .2rem;
                        overflow: hidden;
                    }

                    .name {
                        font-size: .38rem;

                    }

                }
            }

        }

    }

</style>
